import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";

export const GetAllPublic_ST_TimePeriod = createAsyncThunk(
  "GetAllPublic_ST_TimePeriod/GetAllPublic_ST_TimePeriod",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Public_ST_TimePeriod/GetAllPublic_ST_TimePeriod",
        parameters
      );
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublicTimePeriod = createSlice({
  name: "PublicTimePeriod",
  initialState: {
    PublicTimePeriod: [],
    loadingPublicTimePeriod: false,
    errorPublicTimePeriod: null,
   
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPublic_ST_TimePeriod.pending, (state, action) => {
        state.loadingPublicTimePeriod = true;
        state.PublicTimePeriod = action.payload;
        state.errorPublicTimePeriod = null;
      })
      .addCase(GetAllPublic_ST_TimePeriod.fulfilled, (state, action) => {
        state.loadingPublicTimePeriod = false;
        state.PublicTimePeriod = action.payload;
      })
      .addCase(GetAllPublic_ST_TimePeriod.rejected, (state, action) => {
        state.loadingPublicTimePeriod = false;
        state.PublicTimePeriod = action.payload;
      });
  },
});

export default PublicTimePeriod.reducer;